import { FC } from "react";
import { Icon } from "./components/Icon";

const ArrowUp: FC = ({ ...props }) => {
  return <Icon {...props} d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />;
};

export { ArrowUp };
